<template>
    <div id="foot_block_newsletter" class="container-fluid">
        <div class="block_newsletter">
            <div class="content">
                <div class="content_post">
                    <div class="card_newsletter">
                        <div class="text">
                            <div v-if="success_info" style="height: 440px;">
                                <div>
                                    <h2 style="color:#009790;">
                                        Te hemos enviado un correo
                                    </h2>
                                    <h2>
                                        Te damos la bienvenida a la newsletter de Babyplant
                                    </h2>
                                    <p>
                                        ¡Gracias por tu suscripción! Te hemos enviado un correo de confirmación.
                                        A partir de ahora te informaremos sobre nuestras novedades y noticias de interés
                                    </p>
                                </div>
                            </div>
                            <div v-else>
                                <div>
                                    <h2>
                                        ¿Quieres estar al día con Babyplant?
                                    </h2>
                                    <p>
                                        Suscríbete a nuestra newsletter y se el primero en recibir ofertas
                                        especiales. Además, te pondremos al día con las últimas
                                        tendencias y consejos que te ayudaran a que tu día a día
                                        profesional sea más fácil.
                                    </p>
                                </div>
                                <div>
                                    <form>
                                        <div class="bp-form-group">

                                            <div class="content-group">
                                                <div class="type-client-selection">
                                                    <div class="radio-input-block">
                                                        <div class="radio-input-item">
                                                            <input type="radio" tabindex="0" id="radio_agricultor" name="tipo_cliente" value="22" v-model="form.tipo">
                                                            <label for="radio_agricultor" class="text" style="padding:0; padding-left: 30px">Agricultor</label>
                                                        </div>
                                                        <div class="radio-input-item">
                                                            <input type="radio" tabindex="0" id="radio_agrotienda" name="tipo_cliente" value="21" v-model="form.tipo">
                                                            <label for="radio_agrotienda" class="text" style="padding:0; padding-left: 30px">Agrotienda</label>
                                                            <div v-for="error in errors.tipo" class="invalid-feedback">
                                                                {{ error }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="content-group">
                                                <div>
                                                    <label for="email" class="form-label">Tu correo electrónico</label>
                                                    <div class="content-input">
                                                        <input id="email" type="text" class="form-element" name="email" v-model="form.email" required>
                                                        <div v-for="error in errors.email" class="invalid-feedback">
                                                            {{ error }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="invalid_info" class="invalid-feedback" v-html="invalid_info">
                                        </div>
                                        <div class="bp-form-group col-6">
                                            <a class="submit-btn" @click="submitForm()">
                                                <b-spinner v-if="loading" variant="success" label="Spinning"></b-spinner>
                                                <span v-else>Suscribirme</span>
                                            </a>
                                        </div>
                                    </form>
                                </div>
                                <p>
                                    <a class="proteccion_datos" :href="route('info.politica.privacidad')">
                                        En nuestra sección de protección de datos se puede obtener más información sobre cómo procesa los datos Babyplant.
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                'form': {
                    'tipo': null,
                    'email': null,
                },
                'errors': [],
                'success_info': '',
                'invalid_info': '',
                'loading': false
            }
        },
        methods: {
            submitForm: function () {
                if(!this.loading){
                    this.loading = true;

                    axios.post(this.route('newsletter.subscribe'), this.form).then(response => {
                        this.loading = false;

                        this.success_info = response.data.info;
                        this.invalid_info = '';

                        this.form = {tipo: "", email: ""};
                        this.errors = [];
                    }).catch(e => {
                        this.loading = false;
                        this.errors = (e.response.data.errors)?e.response.data.errors:[];

                        this.success_info = '';
                        this.invalid_info = e.response.data.info;
                    });
                }
            }
        }
    }
</script>
